import { Col, Row } from 'react-bootstrap';
import GenerationTimingsChart from './GenerationTimingsChart';

const GenerationTimings = ({ monitoringBlock, g2Model, g3Model }) => {
  const dates = g3Model.SDATA || [];
  const sprayData = monitoringBlock.alcm_spray_data;
  const trapCatchData = g2Model.trap_catch;
  const eggData = (g2Model.egg || []).map((egg) => ({
    ...egg,
    amount: (egg.amount / 40) * 100
  }));
  const gddAccumulationData = g3Model.GDD_ACCUMULATION || [];

  return (
    <Row>
      <Col>
        <GenerationTimingsChart
          dates={dates}
          sprayData={sprayData}
          trapCatchData={trapCatchData}
          eggData={eggData}
          gddAccumulationData={gddAccumulationData}
          g2TrapCatchPeakDate={monitoringBlock.g2_trap_catch_peak_date}
        />
      </Col>
    </Row>
  );
};

export default GenerationTimings;

